import React from "react";
import Skeleton from "react-loading-skeleton";
import { convertSeconds } from "utils/HelperFunctions";

interface CountdownProps {
  seconds: number;
  isLoading: boolean;
  isExpired?: boolean | false;
}

const Countdown: React.FC<CountdownProps> = ({
  seconds: _seconds,
  isLoading,
  isExpired,
}) => {
  const { days, hours, minutes, seconds } = convertSeconds(_seconds);

  return (
    <div className="flex lg:gap-6 md:gap-4 md2:gap-3 gap-2">
      <div className="flex flex-col items-center">
        {isLoading ? (
          <Skeleton width={14} />
        ) : (
          <p
            className={`text-sm font-medium ${
              isExpired ? "text-red" : "text-btnPrimaryActive"
            }`}
          >
            {isExpired ? "00" : days}
          </p>
        )}
        <p className="text-xs font-normal text-txtParagraph">
          {parseInt(days || "0") > 1 ? "Days" : "Day"}
        </p>
      </div>
      <div className="flex flex-col items-center">
        {isLoading ? (
          <Skeleton width={14} />
        ) : (
          <p
            className={`text-sm font-medium ${
              isExpired ? "text-red" : "text-btnPrimaryActive"
            }`}
          >
            {isExpired ? "00" : hours}
          </p>
        )}
        <p className="text-xs font-normal text-txtParagraph">
          {parseInt(hours || "0") > 1 ? "Hours" : "Hour"}
        </p>
      </div>
      <div className="flex flex-col items-center">
        {isLoading ? (
          <Skeleton width={14} />
        ) : (
          <p
            className={`text-sm font-medium ${
              isExpired ? "text-red" : "text-btnPrimaryActive"
            }`}
          >
            {isExpired ? "00" : minutes}
          </p>
        )}
        <p className="text-xs font-normal text-txtParagraph">
          {parseInt(minutes || "0") > 1 ? "Minutes" : "Minute"}
        </p>
      </div>
      <div className="flex flex-col items-center">
        {isLoading ? (
          <Skeleton width={14} />
        ) : (
          <p
            className={`text-sm font-medium ${
              isExpired ? "text-red" : "text-btnPrimaryActive"
            }`}
          >
            {isExpired ? "00" : seconds}
          </p>
        )}
        <p className="text-xs font-normal text-txtParagraph">
          {parseInt(seconds || "0") > 1 ? "Seconds" : "Second"}
        </p>
      </div>
    </div>
  );
};

export default Countdown;
